import { render, staticRenderFns } from "./ManPreventivaOsHistorico.vue?vue&type=template&id=8b13c78a&"
import script from "./ManPreventivaOsHistorico.vue?vue&type=script&lang=js&"
export * from "./ManPreventivaOsHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports